export const FORGE_VIEWER_CONFIG = {
  env: 'AutodeskProduction2',
  api: 'streamingV2_EU',
} as const;
